import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { arutyps,arutypsa,getsid,showhidediv,sets,loadwidgate,getloginuser,setlogininfo,gets,Exituser} from './userdefaultdata';
import { getmessage,wrongmsg,clearform,displayprofile } from './Dynamictable';
import {txtnullchk,isvaluenull,isvalidatemail,isvalidpin,isvalidatedob,isequal,isvldunm} from './validation';
import Usersession from './Usersession';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';
 
export default class Createsubuser extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
	usertyeopt:-1,
	userpfpid:1,

	citycode:'',
	dob:"",
        name: "",
        type: "1",
        pin: "",
	email:"",
        msg: "",
	passwrd:"",
        typeoption: null,
        respdata: null,
	usercode: '',
        isVisible: true,
        resm: null,
        url: "",
	usertps: [{ value: 0, label: 'Female' }],
        citycods: [{ value: 'DEL', label: 'Delhi' }],
	username:"",
	superid:"",	
        userpfps: [{ value: 1, label: 'p1' },{ value: 2, label: 'p2' },{ value: 3, label: 'p3' },{ value: 4, label: 'p4' },{ value: 5, label: 'p5' },{ value: 6, label: 'p6' },{ value: 7, label: 'p7' },{ value: 8, label: 'p8' },],
       
    };
    pagetextboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	
        if(id == 'txtusername'){
        
	 this.setState({ name: elvalue });
	}
	
	else if(id == 'txtdob'){
	 this.setState({ dob: elvalue });
	}
	else if(id == 'txtpin'){
	 this.setState({ pin: elvalue });
	}
   }
   isvalidatedctrls(){
	let isvalidate = true;
	
	if(isvaluenull(this.state.name)){
	  getmessage('Name should not Blanck','');
	  return false;
	}
	 else if(this.state.name.length < 4 || this.state.name.length > 14){
	  getmessage('User name within 4 to 14 alphanumeric','');
	  return false;
	}

        else if(!isvldunm(this.state.name)){
          getmessage('Only alphanumeric allowed','');
	  return false;

	}
	else if(!isvalidatedob(this.state.dob)){
	  getmessage('Enter valid DOB','');
	  return false;
	}
	else if(this.state.usertyeopt == -1){
	 getmessage('Please select user type','');
	  return false;

	}
	else if(isvaluenull(this.state.dob)){
	 getmessage('Enter Date of Birth','');
	  return false;

	}	
	
        
	
	return isvalidate;	
    }	
    
    utypeChange(event: any) {

        const typevalue = event.value;
       this.showpfpdv();
       
        this.setState({ usertyeopt: typevalue });
	

    }
   
	
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
     
        
        this.setserverurl();
        this.setState({ usertps: arutyps });
        const unm = gets('Username');
 	this.setState({ username: unm });

	this.Securitycheckcrt();
        
        
        //   const room = document.getElementById('txtpin') as HTMLElement;



    }
    Securitycheckcrt(){
         //sets('79','NA','testuser','NA');
        
	//const superid = getsid();
        
         showhidediv(false,'Signupdivnew');
	showhidediv(true,'pincheckdiv');
        
         

    }
    checkpin(e:any){
        const localpin = gets('Userpin');
        const cpin = document.getElementById('txtpin') as HTMLInputElement;
       if(cpin){
        var tx = cpin.value;
	if(isequal(tx,localpin)){
	   showhidediv(true,'signuptop');
	   
	   loadwidgate('container',5);
           
	}
	else{
          getmessage('Invalid pin','');

	}
	}
	e.preventDefault()

    }
    forgotpin(e:any){
	//loadwidgate('Logindiv',6);

	e.preventDefault()

    }

    typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		
		e.preventDefault();

     };
     DisplayLogindiv(e:any){
      loadwidgate('container',7);
      e.preventDefault();

     }
     insertusersignup(e: any){
	 try {
		if(this.isvalidatedctrls()){
		
          	const udb = this.state.dob;
                const suid = getsid();
                const isfml = this.state.usertyeopt==1?0:1;
		//alert(suid);
            	//alert(this.state.usertyeopt);	
		const nm =this.state.name;
                const response = axios.post(Configdata.srvurl + '/insertsubuser', {
    		sid: suid,
		uname:nm,
    		utypeid: 0,
    		udob: udb,
	        pfpid:this.state.userpfpid,
	        isf:isfml,
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		 
		const usercd = result.data;
                const ucd = usercd.split(',')[0]; 
                if(ucd != 'Please choose another user name'){

                const ucdid = usercd.split(',')[1]; 
                var sucdid = 0;
               if(ucdid) sucdid = parseInt(ucdid);
               var sbusers = Usersession.getsubusers();
               
              const superid = getsid();
               const nwuser = {mid:sucdid,mpid:superid,mupoints:10,mofferid:0,muname:nm,mudob:udb,mutypeid:0,isf:isfml.toString()};
              const updateusers = sbusers.concat(nwuser)
             Usersession.setsubusers(updateusers);

                sets('NA','NA',nm,'NA');
                  Exituser();
                 }
               	getmessage(ucd,'');

	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
		wrongmsg();
        }

	
      	e.preventDefault();


     }	
     
     clearadminusermailid(){

	const adminmail = Usersession.getGuestmailid();
     
     }	
    closepfpdv(e:any){
	showhidediv(true,'selectpfpdv');

       e.preventDefault();

    }
    showpfpdv(){
	showhidediv(false,'selectpfpdv');
    }
    addpfp(e:any,vl:any){
        this.deseletpfp();
      
	this.setState({ userpfpid: vl });
       const eid = 'p'+vl;
       const dv = document.getElementById(eid) as HTMLElement;
        dv.style.borderStyle="solid";
        dv.style.borderRadius="10px";
        dv.style.borderColor="red";


	e.preventDefault();

    }
   deseletpfp(){
     for(let i=1;i<9;i++){
       
       const eid = 'p'+i;
       const dv = document.getElementById(eid) as HTMLElement;
        dv.style.borderStyle="solid";
        dv.style.borderRadius="10px";
        dv.style.borderColor="yellow";

        
     }
   }
 render() {

   
     return (

         <form id="frmsignup">
        <div id="signuptop" className="per100">
	<div className="per100" id="Signupdivnew">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table style={{height:'70vh',backgroundColor:'antiquewhite'}} className="postingtable">
		

		<tr>
		<td>
			<div className="postingrowdiv">
			<input type="text" placeholder="Enter User name" onChange={e => this.pagetextboxChange(e)} id="txtusername" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div style={{color:'black'}} className="postingrowdropdown">
    <Select placeholder="Select Gender"  onChange={e => this.utypeChange(e) } id="utyp" options={this.state.usertps} className="postingtxtbox" />

			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div style={{display:'none'}} className="postingrowdropdown">
    <Select placeholder="Select City" id="ucity" options={this.state.citycods} className="postingtxtbox" />
		</div>
		<div className="postingrowdiv">
		<input type="text" placeholder="Enter DOB(yyyy-mm-dd)" onChange={e => this.pagetextboxChange(e)} id="txtdob" 			className="postingtxtbox" />
		</div>

			
		</td>
		</tr>

		
		
		
		<tr>
		<td>
			<div className="postingrowdiv">
				
				  
				    <a href="#" onClick={e => this.insertusersignup(e)} title="Partner">

					<div className="searchtype" id="btnsingup" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			Create	
					</div>
				    </a>
		     		
		     		

			</div>
			
		</td>
		</tr>
		

	   </table>
	 </div>		
	</div>
	
	</div>
        <div style={{display:'none'}} className="userpinset" id="subpincheckdivnew">
               
		<div id="pindiv" className="middlepivdiv">
                 
	       </div>
	</div>
        <div className="userloginset"  id="Logindiv">

	</div> 
         <div id="selectpfpdv" style={{display:'none',zIndex:'35000'}} className="cu-profile-photo-s">
	   <div style={{height:'auto',width:'100%'}}>  
 	    <div className="search-title-bar">
                       	<div className="search-title">
			  Profile photo
			</div>
                       
			<a href="#" onClick={e=>this.closepfpdv(e)} title="Profile photo">
			<div className="search-title-toggle" id="closdvpfpselect">
			  X
			</div>
			</a>
	    </div>
            <div id="pfplist" style={{height:'40vh',overflowY:'auto',display:'block'}}>
		{
			this.state.userpfps.map((row,index)=>(
                       <a href="#" style={{height:'12vh'}}  onClick={e=>this.addpfp(e,row.value)} className="blanka" >
			  <div id={row.label}  className="upfpselect">	
	  			{this.state.usertyeopt==0?(
                            <Girlspfp  itemid={row.value} wth={'9vw'}  hgt={'12vh'}/>
          			):(
          		 <Boyspfp  itemid={row.value} wth={'9vw'}  hgt={'12vh'}/>
				)}


			    </div>
			</a>
			))
                      }

	    </div>
            
	</div>
       <a href="#" onClick={e=>this.closepfpdv(e)} title="select photo">

           <div id="Selected" style={{bottom:'5px',right:'10px',position:'absolute'}} className="c-usr-profile">
                     Select
	    </div>
        </a>	
	</div>  
 
	
        </div>
   	</form>
    
   
      );
}
}

